import { render, staticRenderFns } from "./PrematchPreviewPage.vue?vue&type=template&id=d56aea92"
import script from "./PrematchPreviewPage.vue?vue&type=script&lang=js"
export * from "./PrematchPreviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports